/**
 * 再买一单按钮
 */
import { Icon } from '@cps'
import React, { FC, useEffect, useMemo } from 'react'
import { orderMobx, storeMobx, productCenter, cartMobx, productMobx, restaurantCenter, replaceCartItemPk } from 'restaurant'
import { modalLayer, loadingLayer, showMsg, useHistoryNew } from '@utils'
import { SoldWarnModal } from '@pages/checkout/modal'
import './index.scss'
import { refundMobx } from '@mobx/order'
import { TEOrderStatus } from '@common/enum/order.enum'
import { TEEatType } from 'restaurant/mobx/store.mobx'

interface IProps {
  info: IOrder;
}

const OrderRefundBtn: FC<IProps> = (props: IProps) => {
  const { info } = props
  const { refundConfig: { eatType }, refundConfig } = refundMobx
  const { ordersId } = info
  const history = useHistoryNew()
  /** 手机可以退款，目前只可以退款 */
  const canMobileRefund = useMemo(() => {
    return info.status === TEOrderStatus.Success && eatType.includes(info.eatType)
  }, [eatType, info])
  /** 点击再来一单 */
  const handle = async (event) => {
    event.stopPropagation()
    history.push(`/refund/${info.ordersId}`)
  }

  useEffect(() => {
  }, [])

  return (
    <div className='order-refund-container' onClick={handle}>
      <span>{i18n.t('refund.refundRequest')}</span>
    </div>
  )
}

export default OrderRefundBtn
